import React, { Fragment, useState } from "react";
import apiEndPoint from "../../../utils/apiEndPoint";
import { Navigate, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { loadFromLocalStorage, saveToLocalStorage } from "../../../utils/LocalStorageUtils";
import { apiCall, failedMessage, setDefaultHeader, successMessage } from "../../../utils/httpClient";
import { Spinner } from "react-bootstrap";
import { useEffect } from "react";
import "../auth.css";

function LoginMobile() {
  const [showOtp, setShowOtp] = useState(false);
  const [mobile, setMobile] = useState("");
  const [verificationOtp, setVerificationOtp] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const authData = loadFromLocalStorage("AUTH_DATA");
  const [languageData, setLanguageData] = useState(null);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])
  if (authData?.token) {
    return <Navigate to="/" />;
  }

  const validationForget = () => {
    let isError = true;
    let errorMessage = {};
    if (verificationOtp === undefined || verificationOtp === "") {
      isError = false;
      errorMessage["verificationOtp"] = "Please Enter OTP";
    }
    setErrorMessage(errorMessage);
    return isError;
  };
  const getVerificationOtp = async () => {
    if (mobile.length == 10) {
      setErrorMessage({ ...errorMessage, mobile: '' });
      setLoading(true);
      const params = { mobile: mobile };
      // const { data } = await apiCall("post", apiEndPoint.LOGINWITHMOBILE, params);
      const { data } = await apiCall("post", apiEndPoint.LOGINFORMOBILE, params);
      if (data.status !== 200) {
        failedMessage(data.message);
      }
      if (data.status === 200) {
        setShowOtp(true)
      }
      setLoading(false);
    } else {
      setErrorMessage({ ...errorMessage, mobile: 'Please Enter Mobile' });
    }
  };
  const handleLogin = async () => {
    if (validationForget()) {

      setLoading(true);
      const params = { mobile: mobile, otp: verificationOtp };
      // const { data } = await apiCall("post", apiEndPoint.LOGINWITHOTP, params);
      // if (data.status !== 200) {
      //   failedMessage(data.message);
      // }
      // if (data.status === 200) {
      //   setDefaultHeader("token", data.data.token);
      //   saveToLocalStorage("AUTH_DATA", data.data);
      //   navigate("/");
      // }


      const { data } = await apiCall("post", apiEndPoint.LOGINOTPVERIFYMOBILE, params);
      if (data.status !== 200) {
        failedMessage(data.message);
      }
      if (data.status === 200) {
        if (data?.data?.userDetail?.signup_status != undefined && data?.data?.userDetail?.signup_status) {
          console.log('data?.data?.userDetail?.signup_status: ', data?.data?.userDetail?.signup_status);
          setDefaultHeader("token", data?.data?.token);
          saveToLocalStorage("AUTH_DATA", data.data);
          navigate("/");
        } else {
          successMessage(data.message);
          saveToLocalStorage("SIGNUPTOKEN", data.data?.token);
          saveToLocalStorage("SIGNUPMOBILE", mobile);
          navigate("/signupDetail");
        }
      }
      setLoading(false);
    }
  };
  return (
    <div>
      <form>
        <div className="form-group">
          <div className="row">
            <div className="col-lg-12 mt-adj">
              <div className="input-field-box">
                <label>{languageData?.enterUrmobi} </label>
                <input
                  htmlFor="mobile"
                  value={mobile}
                  type="number"
                  size="large"
                  onChange={(e) => setMobile(e.target.value)}
                  placeholder={"e.g. 9000000009"}
                  className={`${errorMessage.mobile ? "input-errmsg" : ""
                    } form-control`}
                  disabled={showOtp ? true : false}
                />
                {errorMessage?.mobile && (
                  <span className="er-msg-show">
                    {errorMessage?.mobile}
                  </span>
                )}
              </div>
            </div>
            {showOtp &&
              <div className="col-lg-12 mt-adj">
                <div className="input-field-box">
                  <label>Enter your OTP</label>
                  <input
                    htmlFor="verificationOtp"
                    value={verificationOtp}
                    type="number"
                    size="large"
                    onChange={(e) => setVerificationOtp(e.target.value)}
                    placeholder={"6 digit OTP"}
                    className={`${errorMessage?.verificationOtp ? "input-errmsg" : ""
                      } form-control`}
                  />
                  {errorMessage?.verificationOtp && (
                    <span className="er-msg-show">
                      {errorMessage?.verificationOtp}
                    </span>
                  )}
                </div>
              </div>
            }
          </div>
          <br />
          <div className="sav-btn mt-adj">
            <button
              type="button"
              onClick={() => { showOtp ? handleLogin() : getVerificationOtp() }}
              disabled={isLoading}
            >
              {isLoading ? (
                <Spinner animation="border" size="sm" role="status" />
              ) : (showOtp ? "Login" : "Get OTP")}
            </button>
          </div>
        </div>
        <br />
      </form>
    </div>
  );
}

export default LoginMobile;